<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormSelect
      v-bind="$props"
      :config="mergedConfig"
      :customLabel="normalizedOptionLabel"
      v-on="$listeners"
    />
    <PreviewPhaseIntegrationState
      v-if="showPhaseIntegration && value"
      :phaseId="value"
    />
  </div>
</template>

<script>
import PreviewPhaseIntegrationState from '@/components/Integration/PreviewPhaseIntegrationState'
import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import { inject } from '@vue/composition-api'

export default {
  extends: FormSelect,
  components: {
    FormSelect,
    PreviewPhaseIntegrationState,
  },
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  setup () {
    const showPhaseIntegration = inject('SHOW_PHASE_INTEGRATION', false)

    return {
      showPhaseIntegration,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    ...mapGetters({
      phases: 'phases/getAll',
    }),
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: this.normalizedOptions,
        ...this.config,
      }
    },
    normalizedOptions () {
      const options = this.phases.map(el => el.id)
      return options
    },
  },
  methods: {
    getPhaseName (phaseId) {
      return this.phases.find(({ id }) => phaseId === id)?.name
    },
    normalizedOptionLabel (option) {
      return this.getPhaseName(option)
    },
    clear () {
      this.update(undefined)
    },
  },
}
</script>
